import { lazy } from "react";
import type { ComponentType } from "react";

// 코드 스플리팅 청크 로드 실패(ChunkLoadError) 자가 복구.
//  - dev: 라우트 청크 on-demand 컴파일/프록시 흔들림으로 1회성 실패가 잦음 → 짧게 재시도.
//  - prod: 배포로 청크 해시가 바뀌면 옛 인덱스를 들고 있는 탭이 실패 → 1회 새로고침으로 최신 취득.
// 무한 새로고침 방지를 위해 sessionStorage 플래그로 reload는 1회만.
const RELOAD_KEY = "chunk-reload-attempted";

// ComponentType<any>: prop 없는 라우트 컴포넌트와 선택적 prop을 받는 컴포넌트(예: 임베드 가능한
//  CRMFlowBuilderPage) 를 모두 lazy 로드할 수 있게 허용. 라우트는 항상 prop 없이 렌더된다.
export default function lazyWithRetry<T extends ComponentType<any>>(
  importer: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await importer();
      window.sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (err) {
      // 일시적 실패 재시도 2회
      for (let i = 0; i < 2; i++) {
        await new Promise((r) => setTimeout(r, 400));
        try {
          const mod = await importer();
          window.sessionStorage.removeItem(RELOAD_KEY);
          return mod;
        } catch {
          /* 다음 재시도 */
        }
      }
      // 그래도 실패 → 옛 번들/청크일 가능성. 1회만 새로고침.
      if (!window.sessionStorage.getItem(RELOAD_KEY)) {
        window.sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        // reload 진행 중 — 렌더 멈추도록 영구 pending 반환.
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }
  });
}
